import { RoutePath } from 'enums/routePath';

const ROOT = `/account-onboarding`;

const ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_FIELDS = `${ROOT}/assigned-accounts-fields`;
const ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_USER = `${ROOT}/assigned-accounts-user`;
const ACCOUNT_ONBOARDING_INTEGRATION_PROGRESS = `${ROOT}/integration-progress`;
const ACCOUNT_ONBOARDING_MS365_INTEGRATION = `${ROOT}/365-integration`;
const ACCOUNT_ONBOARDING_PLAN_ONBOARDING = `${ROOT}/step-one`;
const ACCOUNT_ONBOARDING_PLAN_ONBOARDING_STEP_TWO = `${ROOT}/step-two`;

const paths = {
  [RoutePath.ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_FIELDS]:
    ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_FIELDS,
  [RoutePath.ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_USER]:
    ACCOUNT_ONBOARDING_ASSIGNED_ACCOUNTS_USER,
  [RoutePath.ACCOUNT_ONBOARDING_INTEGRATION_PROGRESS]:
    ACCOUNT_ONBOARDING_INTEGRATION_PROGRESS,
  [RoutePath.ACCOUNT_ONBOARDING_MS365_INTEGRATION]:
    ACCOUNT_ONBOARDING_MS365_INTEGRATION,
  [RoutePath.ACCOUNT_ONBOARDING_PLAN_ONBOARDING]:
    ACCOUNT_ONBOARDING_PLAN_ONBOARDING,
  [RoutePath.ACCOUNT_ONBOARDING_PLAN_ONBOARDING_STEP_TWO]:
    ACCOUNT_ONBOARDING_PLAN_ONBOARDING_STEP_TWO,
};

export const pathArray = Object.values(paths);

export default paths;
